
import { cleanPhoneNumber } from "@/app/infrastructures/misc/common-library/Whatsapp";
import { defineComponent } from "vue";
import { createI18n } from "vue-i18n";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import router from "../../router";

export default defineComponent({
  name: "HelpCenter",
  setup() {
    const i18nInstance = createI18n({
      legacy: false,
      locale: router.currentRoute.value.query?.is_en === "true" ? "my" : "id",
      fallbackLocale: "id",
      globalInjection: false,
      messages: {
        en,
        id,
        my
      }
    });
    const t = i18nInstance.global.t;

    return {
      t,
      cleanPhoneNumber
    };
  }
});
